import { render, staticRenderFns } from "./video-data-chart.vue?vue&type=template&id=ab733430&scoped=true"
import script from "./video-data-chart.vue?vue&type=script&lang=js"
export * from "./video-data-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab733430",
  null
  
)

export default component.exports